import React from 'react';
import { EventCategoryPage } from '../../components/Events/EventCategoryPage';
import { EVENT_CATEGORIES } from '../../data/eventCategoryData';
const ConventionsFestivals = () => <EventCategoryPage config={EVENT_CATEGORIES['conventions-festivals']} data-id="element-9848" data-mp="wr707nlasgij" />;
export default ConventionsFestivals;